import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage, { Section, List, SUPPORT_EMAIL } from '../Components/LegalPage';

export default function ShippingPolicyPage() {
  return (
    <LegalPage
      title="Shipping & Delivery Policy"
      tagline="SoapLab is an online service. Nothing is shipped; your plan is delivered to your account instantly."
      effective="October 23, 2026"
    >
      <Section id="delivery" title="1. How SoapLab is delivered">
        <List items={[
          'SoapLab is web-based software used in your browser. We do not sell or ship any physical products.',
          'Pro features are activated on your SoapLab account as soon as your payment is confirmed, usually within a few minutes.',
          'There are no shipping or delivery charges, and SoapLab can be used from anywhere with an internet connection.',
        ]} />
      </Section>

      <Section id="problems" title="2. If your plan doesn't activate">
        <p className="bodytext">
          If Pro is not active on your account within one hour of a successful payment, contact us at{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> or through the <Link to="/contact">Contact page</Link> with
          your account email and payment ID. We will activate it or refund the payment under
          our <Link to="/refund-policy">Cancellation &amp; Refund Policy</Link>.
        </p>
      </Section>
    </LegalPage>
  );
}
